package uk.co.nickthecoder.kyd.nodes

import uk.co.nickthecoder.glok.backend.backend
import uk.co.nickthecoder.glok.util.Matrix
import uk.co.nickthecoder.kyd.Actor
import uk.co.nickthecoder.kyd.Stage

/**
 * A view of a [Stage].
 * A [StageView] is a child node of [ActView].
 *
 * There are two implementations, [PlayStageView] when _playing_ the game, and `EditStageView` used by the Kyd Editor.
 */
abstract class StageView(val stage: Stage) : StageOrActView() {

    /**
     * Returns an arbitrary size.
     * StageView are typically forced to be a particular size by the parent node.
     */
    override fun nodePrefWidth(): Float {
        return 0f
    }

    /**
     * Returns an arbitrary size.
     * StageView are typically forced to be a particular size by the parent node.
     */
    override fun nodePrefHeight(): Float {
        return 0f
    }

    override fun draw() {
        stage.prepareDraw()
        backend.transform(worldToScene) {
            for (actor in stage.actors) {
                val matrix = actor.localToWorld
                drawActor(actor, matrix)
            }
        }
    }

    open fun drawActor(actor: Actor, localToWorld: Matrix) {

        for (child in actor.children) {
            if (child.isBelow) {
                drawActor(child, localToWorld * child.localToWorld)
            }
        }
        actor.appearance.draw(localToWorld)

        for (child in actor.children) {
            if (! child.isBelow) drawActor(child, localToWorld * child.localToWorld)
        }
    }

}
